import React from "react";
import EventsContent from "../content/EventsContent";
import Layout from "../layout/Layout";

const Events = () => {
  return (
    <Layout>
      <EventsContent />
    </Layout>
  );
};

export default Events;
